import { render, staticRenderFns } from "./RootNode.vue?vue&type=template&id=2da57774&scoped=true&"
import script from "./RootNode.vue?vue&type=script&lang=js&"
export * from "./RootNode.vue?vue&type=script&lang=js&"
import style0 from "./RootNode.vue?vue&type=style&index=0&id=2da57774&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da57774",
  null
  
)

export default component.exports